import React from 'react';
import BaseText from '../base-text/BaseText';
import { TextLatoProps } from './TextLato.types';
import { useLatoFont } from './TextLato.logic';
import { TEXT_LATO_CONVERSION_STYLE_MAP, TextLatoConversionKeys } from './TextLato.constants';

const TextLato = (props: TextLatoProps) => {
  return (
    <BaseText
      {...props}
      testID={props.testID ?? 'text-lato'}
      conversionStyleMap={TEXT_LATO_CONVERSION_STYLE_MAP}
      conversionKeys={{
        BOLD: TextLatoConversionKeys.BOLD,
        ITALIC: TextLatoConversionKeys.ITALIC,
      }}
      useFontHook={useLatoFont}
    />
  );
};

export default TextLato;
